(() => {
  if (document.querySelector('[data-trots-about-page], [data-trots-info-page]')) return;

  const EDITORIAL_HANDLES = new Set([
    'over-ons',
    'verkooppunten',
    'levering-verzendkosten',
    'levering-en-verzendkosten',
    'ruilen-retourneren',
    'ruilen-en-retourneren',
    'garantie-klachten',
    'garantie-en-klachten',
    'vragen',
    'privacyverklaring',
    'algemene-voorwaarden'
  ]);

  const QUOTES = {
    'over-ons': [
      "De Achterhoek, doar bunt wi'j TROTS op!",
      'Van streekproducten naar streekgevoel.',
      'Hier laat je zien waar je vandaan komt.'
    ],
    verkooppunten: [
      'Dichtbij te vinden. Overal herkenbaar Achterhoeks.',
      'Lokale winkels, een gedeelde trots.',
      'Samen maken we de Achterhoek zichtbaar.'
    ],
    default: [
      'Duidelijk geregeld, op z\u2019n Achterhoeks.',
      'Persoonlijk, praktisch en dichtbij.',
      'Goed Goan!'
    ]
  };

  const getHandle = () => {
    const parts = window.location.pathname.split('/').filter(Boolean);
    return parts[0] === 'pages' ? (parts[1] || '') : '';
  };

  const findEditorialSource = () => {
    const selectors = [
      'main .main-page .rte',
      'main .page-width .rte',
      'main .shopify-section .rte',
      'main .rte'
    ];
    const candidates = selectors.flatMap((selector) => [...document.querySelectorAll(selector)]);
    return candidates
      .filter((node) => !node.closest('.trots-editorial-v7, .trots-editorial-v071'))
      .filter((node) => node.textContent.trim().length > 220)
      .sort((a, b) => b.textContent.trim().length - a.textContent.trim().length)[0] || null;
  };

  const contentNodes = (source) => {
    const meaningfulSelector = 'h1, h2, h3, p, ul, ol, blockquote, figure, img, video';
    const nodes = [...source.querySelectorAll(meaningfulSelector)].filter((node) => {
      const hasContent = node.textContent.trim() || node.matches('img, video') || node.querySelector('img, video');
      if (!hasContent) return false;

      const meaningfulAncestor = node.parentElement?.closest(meaningfulSelector);
      return !meaningfulAncestor || !source.contains(meaningfulAncestor);
    });

    if (nodes.length) return nodes;

    return [...source.children].filter((node) => node.textContent.trim() || node.querySelector('img, video'));
  };

  const chapterize = (source) => {
    const nodes = contentNodes(source);
    const chapters = [];
    let current = [];

    nodes.forEach((node) => {
      const isHeading = /^(H1|H2|H3)$/.test(node.tagName);
      if (isHeading && current.length) {
        chapters.push(current);
        current = [];
      }
      current.push(node);
    });
    if (current.length) chapters.push(current);

    if (chapters.length > 1) return chapters;

    const fallback = [];
    let group = [];
    nodes.forEach((node) => {
      group.push(node);
      if (group.length >= 3) {
        fallback.push(group);
        group = [];
      }
    });
    if (group.length) fallback.push(group);
    return fallback;
  };

  const removeCounters = () => {
    document.querySelectorAll('main *').forEach((element) => {
      if (element.children.length || !/^\s*\d{2}\s*$/.test(element.textContent)) return;
      element.classList.add('trots-v071-counter');
      element.setAttribute('aria-hidden', 'true');
    });
  };

  const createMedia = (src, alt) => {
    const media = document.createElement('figure');
    media.className = 'trots-editorial-v071__media';

    const image = document.createElement('img');
    image.src = src;
    image.alt = alt;
    image.loading = 'lazy';
    image.decoding = 'async';

    media.appendChild(image);
    return media;
  };

  const normalizeTitle = (value) => value
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase('nl-NL');

  const buildEditorialPage = () => {
    const handle = getHandle();
    if (!EDITORIAL_HANDLES.has(handle)) return;

    document.querySelectorAll('.trots-editorial-v071, .trots-editorial-v7').forEach((node) => node.remove());
    document.querySelectorAll('.trots-v071-source').forEach((node) => {
      node.hidden = false;
      node.classList.remove('trots-v071-source');
    });

    const source = findEditorialSource();
    if (!source) return;
    const chapters = chapterize(source);
    if (!chapters.length) return;

    const quotes = QUOTES[handle] || QUOTES.default;
    const wrapper = document.createElement('div');
    wrapper.className = 'trots-editorial-v071';
    wrapper.setAttribute('data-page-handle', handle);

    chapters.forEach((nodes, index) => {
      const section = document.createElement('section');
      section.className = 'trots-editorial-v071__chapter';

      const copy = document.createElement('article');
      copy.className = 'trots-editorial-v071__copy';
      nodes.forEach((node) => copy.appendChild(node.cloneNode(true)));

      if (handle === 'ruilen-en-retourneren' || handle === 'ruilen-retourneren') {
        copy.querySelectorAll('h1, h2, h3').forEach((heading) => {
          if (heading.textContent.trim().toLocaleLowerCase('nl-NL') === 'product ruilen?') heading.remove();
        });
      }

      if (handle === 'over-ons') {
        copy.querySelectorAll('br').forEach((lineBreak) => {
          lineBreak.replaceWith(document.createTextNode(' '));
        });
        copy.normalize();
      }

      const quote = document.createElement('blockquote');
      quote.className = 'trots-editorial-v071__quote';
      quote.textContent = quotes[index % quotes.length];

      const heading = copy.querySelector('h1, h2, h3');
      const chapterTitle = normalizeTitle(heading?.textContent || '');
      const isOverOnsPage = handle === 'over-ons';
      const isIntroChapter = isOverOnsPage && (index === 0 || chapterTitle.includes('over trots'));
      const isPuzzleChapter = isOverOnsPage && (index === 1 || chapterTitle.includes('puzzel'));
      const isMerchandiseChapter = isOverOnsPage && (index === 2 || chapterTitle.includes('sok') || chapterTitle.includes('merchandise'));

      if (isIntroChapter) {
        section.classList.add('trots-editorial-v071__chapter--bennie');

        const media = createMedia(
          'https://cdn.shopify.com/s/files/1/1029/4994/5686/files/bennie-jolink-achterhoek-vlag-stadion.png?v=1780478406',
          'Bennie Jolink met de Achterhoekse vlag in het stadion'
        );

        section.append(copy, media);
        wrapper.appendChild(section);
        return;
      }

      if (isPuzzleChapter) {
        section.classList.add('trots-editorial-v071__chapter--naoberschap');
        quote.textContent = "De Achterhoek, doar bunt wi'j TROTS op!";

        section.append(quote, copy);
        wrapper.appendChild(section);
        return;
      }

      if (isMerchandiseChapter) {
        section.classList.add('trots-editorial-v071__chapter--merchandise');
        if (heading) heading.textContent = 'Achterhoekse merchandise';

        const continuation = document.createElement('article');
        continuation.className = 'trots-editorial-v071__copy trots-editorial-v071__copy--continuation';
        [...copy.children]
          .filter((child) => child !== heading)
          .slice(2)
          .forEach((child) => continuation.appendChild(child));

        const media = createMedia(
          'https://cdn.shopify.com/s/files/1/1029/4994/5686/files/gerrit-vossers-poah-achterhoek-sokken-boerderij.png?v=1780478405',
          'Gerrit Vossers met Achterhoekse sokken op de boerderij'
        );

        section.append(media, copy);
        wrapper.appendChild(section);

        if (continuation.children.length || continuation.textContent.trim()) {
          const closingSection = document.createElement('section');
          closingSection.className = 'trots-editorial-v071__chapter trots-editorial-v071__chapter--closing';
          closingSection.appendChild(continuation);
          wrapper.appendChild(closingSection);
        }

        return;
      }

      section.append(copy, quote);
      wrapper.appendChild(section);
    });

    source.insertAdjacentElement('afterend', wrapper);
    source.classList.add('trots-v071-source');
    source.hidden = true;
    removeCounters();
  };

  const init = () => {
    buildEditorialPage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.setTimeout(init, 300);
  window.setTimeout(init, 1000);
  document.addEventListener('shopify:section:load', init);
})();
